export interface AdditionalPACData {
  pacNumber?: string,
  paymentType: string,
  court?: string,
  payerName: string,
  payerId: string,
  contactNumber?: string,
  emailId?: string,
  totalAmountPayable: number,
  amountPaid: number,
  balancePayable: number,
  paymentFrequency?: PaymentFrequency,
  paymentCategory?: PaymentCategory,
  paidAmountViaCC?: number,
  payNowCompletedCount?: number; // need to handle for each payment
  selectedAmountPayable?: number;
  payableLineItems?: PayablePaymentLineItem[],
  sessionId?: string,
  paidLineItems?: PaidPaymentCollection[],
  depositDetailsInfo?: DepositDetailsInfo,
  cashCounterID?: string,
  sessionStatus?: string,
  terminalId?: string,
  blocked?: boolean,
  retryAfterSeconds?: number
}

export interface PacUpdateRequest {
  emailId: string,
  contactNumber: string,
  pacNumber?: string,
  selectedAmountPayable?: number
  paymentFrequency: PaymentFrequency,
  paymentCategory: PaymentCategory,
  selectedPacsCount?: number,
  terminalId?: string
}

export interface PayablePaymentLineItem {
  pacNumber: string,
  dueAmount: number,
  dueDate: Date
}

export interface DepositDetailsInfo {
  depositType: string,
  depositCategory: string,
  depositCategoryDisplayValue: string,
  depositTypeDisplayName: string,
  caseNumber: string,
  subCaseNumber?: string,
  remarks?: string,
  createdDate?: Date,
  externalPacNumber?: string

}

export interface PaidPaymentCollection {
  receiptNumber?: string,
  collectionDate? : string,
  paymentMode: string,
  bankCode?: string,
  bankReference?: string,
  chequeNumber?: string;
  paymentAmount: number | null,
  remarks?: string,
  pacNumber?: string,
  transactionId?: string,
  status?: string,
  message?: string
}


export enum PaymentFrequency {
  I = 'I',
  O = 'O'
}

export enum PaymentCategory {
  COURT_DEPOSIT = 'COURT_DEPOSIT',
  COURT_PAYMENT = 'COURT_PAYMENT'
}
